// oss
import OSS from 'ali-oss';

// config
import { config } from '@shakkerai/config';

// services
import { getOssToken } from '@shakkerai/services';

// interval time
// 由于后端的最小过期时间5分钟
// 这里设置刷新token的间隔为4分钟
const intervalTime = 4 * 60 * 60;

/**
 * getOssClient
 * @param {*} bizCode
 * @param {*} isSDTmp
 * @returns
 */
export const getOssClient = async (bizCode, isSDTmp) => {
  try {
    // oss config
    const ossConfig = await getOssConfig(bizCode);
    if (!ossConfig) return;

    // client
    // 没有开阿里云传输加速，不需要传endpoint，只传region即可
    // https://help.aliyun.com/zh/oss/user-guide/regions-and-endpoints?spm=a2c4g.11186623.0.i1#concept-zt4-cvy-5db
    // 目前测试的bucket：liblibai-models和现网的bucket：liblibai-online都是华北二北京
    // 所以region是oss-cn-beijing
    const client = new OSS({
      region: config.oss.ossRegion,
      bucket: isSDTmp ? config.oss.ossBucketForSDTmp : config.oss.ossBucket,
      stsToken: ossConfig.securityToken,
      accessKeyId: ossConfig.accessKeyId,
      accessKeySecret: ossConfig.accessKeySecret,
      refreshSTSTokenInterval: intervalTime,
      refreshSTSToken: async () => {
        const info = await refreshSTSToken(bizCode);
        return info;
      },
    });

    console.info('getOssClient', client);
    return client;
  } catch (error) {
    console.error('getOssConfig', 'get oss token error');
    console.error('getOssConfig', error);
  }
};

// get oss config
async function getOssConfig(bizCode) {
  //
  console.info('getOssConfig');

  // res
  const res = await getOssToken(bizCode, config.env === 'aws');
  if (res.code === -1) {
    console.error('getOssConfig', 'get oss token error');
    return;
  }

  // oss config
  const ossConfig = res.data;
  if (!ossConfig) {
    console.error('getOssConfig', 'no res.data');
    return;
  }

  // check expiration
  const timestamp = new Date(ossConfig.expiration).getTime();
  const currentTimestamp = Date.now();
  if (timestamp <= currentTimestamp) {
    console.error('getOssConfig', '接口返回的过期时间失效');
    return;
  }

  console.info('getOssConfig', ossConfig);
  return ossConfig;
}

// refresh token
async function refreshSTSToken(bizCode) {
  // oss config
  const ossConfig = await getOssConfig(bizCode);
  if (!ossConfig) {
    console.error('refreshSTSToken', 'get oss config fail');
    return;
  }

  //
  console.info('refreshSTSToken');
  return {
    accessKeyId: ossConfig.accessKeyId,
    accessKeySecret: ossConfig.accessKeySecret,
    stsToken: ossConfig.securityToken,
  };
}
